export const MOTOR_GET_DATA = 'motorGetData';
export const MOTOR_RESET_STATE = ' motorResetState';
export const MOTOR_SEARCH_VEHICLE = 'motorSearchVehicle';
export const MOTOR_SET_MODEL = 'motorSetModel';
export const MOTOR_SET_MAKE = 'motorSetMake';
export const MOTOR_UPDATE_DATA = 'motorUpdateData';
export const MOTOR_UPDATE_VALUE = 'motorUpdateValue';
export const MOTOR_SET_OFFER_STEP = 'motorSetOfferStep';
export const MOTOR_SET_PAYMENT_STEP = 'motorSetPaymentStep';
export const MOTOR_CALCULATION = 'motorCalculation';
export const MOTOR_PACKAGE_SELECTION = 'motorPackageSelection';
export const MOTOR_PACKAGE_CALCULATION = 'motorPackageCalculation';
export const MOTOR_QUOTATION = 'motorQuotation';
export const MOTOR_SET_PROMO = 'motorSetPromo';
export const MOTOR_SET_LANGUAGE = 'motorSetLanguage';

// export const EMAIL_VALIDATION = 'emailValidation';
// export const OTP_VALIDATION = 'otpValidation';
